import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HalfYearlyService } from 'src/app/service/half-yearly.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { config } from 'src/app/valueObject/config';
import { saveAs } from 'file-saver';
import { base64StringToBlob } from 'blob-util';
import { ToastrService } from 'ngx-toastr';
import { DataTablesModule } from 'angular-datatables';


@Component({
    selector: 'app-member-half-yearly-report',
    templateUrl: './member-half-yearly-report.component.html',
    styleUrls: ['./member-half-yearly-report.component.css'],
    standalone: false
})
export class MemberHalfYearlyReportComponent implements OnInit{
  readOnlyData: any;
  halfYearlyForm: FormGroup;
  formArray1: any = [];
  totalASum:number = 0;
  totalBSum:number = 0;
  memCode: any;
  memId: any;
  memName: string;
  entityType: any;
  user: any = {};
  memberData: any = {};
  config: any = config;
  isReadOnly: boolean = true;
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  nwrthOriginalFlname: string;
  file:File;
  uploadDetails: any;
  quarterDetails: any = [];
  enableData: any;
  enable: boolean;
  quarterList: any;
  eligibleQuarter: any;
  eligibleYear: any;
  year: any;
  cutOffDate: any;
  isSubmitted: any;
  halfYearEndDate: any;
  alert: boolean;
  limit: any;
  memberDetails: any;
  memCategory: any;
  minNetworth: any;
  makerFlag:boolean=false;
  checkerFlag:boolean=false;
  halfYearlyNetworthId: any;
  halfYearly:any;
  commentForMakerChecker:any;
  status: any;
  makerId: any;
  makerDTM : any;
  makerComment : any;
  checkerId : any;
  checkerDTM : any;
  checkerComment : any;
  action:string;
  actionFlag: boolean=false;
  adminComment: any;
  memberFlag: boolean=false;
  makerCommentFlag: boolean = false;
  checkerCommentFlag: boolean = false;

  get f() {
    return this.halfYearlyForm.controls;
  }
  get formUploadFile() {
    return this.halfYearlyForm.get("networthFileInfo") as FormArray;
  }

  constructor(private formBuilder: FormBuilder,
    private halfYearlyService: HalfYearlyService,
    private userDetailsService: UserDetailsService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router : Router) { 
      this.route.queryParams.subscribe(params => {
        if (params['id']) {
          this.readOnlyData = this.halfYearlyService.getaddHalfYearlyByRef(params['id']);
          console.log("readonlydata"+this.readOnlyData);
        }
      });
    }

    ngOnInit(): void {

      this.user = this.userDetailsService.getUserDetails() || {};
      this.memCode = this.user.entityCode;
      this.memId = (<number>this.user.entityCode ) + "";
      this.entityType = this.user.entityType;
      this.isReadOnly = true;
      this.getMemberCategory();
      if(this.user.entityType=='ENIT'){
        this.memberFlag=true;
      }
  
      // this.getQuarterForSubmission();
      // this.createFormInputs();
      // this.getMemberDetails();
      // this.getEnable();
      
    //Networth Category
   

      //this.getMemberLimit();
      this.halfYearlyForm = this.formBuilder.group({
        memberName: [this.readOnlyData?.memberName],
        memberCode:  [this.readOnlyData?.memberCode],
        memCategory: [this.memCategory],
        minNetworth: [this.readOnlyData?.limit],
        asOnDate: [this.readOnlyData?.asOnDate],
        nameOfCaFirm: [this.readOnlyData?.nameOfCaFirm],
        udin :[this.readOnlyData?.udin],
        membershipNoCertifyingCa: [this.readOnlyData?.membershipNoCertifyingCa],
        methodOfComputation: [this.readOnlyData?.methodOfComputation],
        networthFileInfo: this.formBuilder.array([]),
         paidUpCapital:[this.readOnlyData?.paidUpCapital],
         reservedCreatedOfProfit:[this.readOnlyData?.reservedCreatedOfProfit],
         cerditBalanceProfitAndLoss: [this.readOnlyData?.cerditBalanceProfitAndLoss],
         securityPermium: [this.readOnlyData?.securityPermium],
         accumulatedLosses: [this.readOnlyData?.accumulatedLosses],
         deferredExpenditure: [this.readOnlyData?.deferredExpenditure],
         miscellaneousExpenses: [this.readOnlyData?.miscellaneousExpenses],
         otherActivitiesOutsideIfsc: [this.readOnlyData?.otherActivitiesOutsideIfsc],
         totalNetworth: [this.readOnlyData?.totalNetworth],
         totalA: [this.readOnlyData?.totalA],
         totalB: [this.readOnlyData?.totalB],
        halfYearlyNetworthId:[this.readOnlyData?.halfYearlyNetworthId],
        revisedUpload:[],
        commentForMaker:[this.readOnlyData?.makerComment],
        commentForChecker:[this.readOnlyData?.checkerComment],
         changeCMIRequest :[this.readOnlyData?.cmiFormat],
        liquidAssets:[this.readOnlyData?.liquidAssets],
        cashBankBal :[this.readOnlyData?.cashBankBal],
        fixedDeposits :[this.readOnlyData?.fixedDeposits],
        goverSecurities :[this.readOnlyData?.goverSecurities],
        totalNetworth2025 :[this.readOnlyData?.totalNetworth2025],
        marginTrading :[this.readOnlyData?.marginTrading],
        baseMinimumCapital :[this.readOnlyData?.baseMinimumCapital],
        liabilities :[this.readOnlyData?.liabilities],
        totalNetworth2025B:[this.readOnlyData?.totalNetworth2025B],
        totalNetworth2025AB :[this.readOnlyData?.totalNetworth2025AB],
        
      })
      // this.formArray1 = this.readOnlyData.networthFileInfo
      //   const add = this.halfYearlyForm.controls.networthFileInfo as FormArray;
      //   this.formArray1.forEach((Details: any) => {
      //     if(Details.nwrthFileType=='Networth_Certificate'){
      //       add.push(this.formBuilder.group({
      //         nwrthFileId: [Details.nwrthFileId],
      //         nwrthOriginalFlname: [Details.nwrthOriginalFlname],
      //         nwrthSystmFlname: [Details.nwrthSystmFlname],
      //         nwrthFileType: [Details.nwrthFileType]
            
      //       })
      //       )
      //       this.halfYearlyForm.controls.networthFileInfo = add;
      //     }
      //       else{
      //         this.uploadDetails=Details;
      //         this.f.revisedUpload.setValue(this.uploadDetails.nwrthSystmFlname);
      //       }
      //   })
      //   this.halfYearlyForm.controls.networthFileInfo = add;

          
        if(this.readOnlyData.maker==null){
          this.makerFlag=true;
          this.actionFlag=true;
         }
         if(this.readOnlyData.maker!=null && this.readOnlyData.checkerId==null && this.readOnlyData.maker!=this.user.entityCode){
          this.checkerFlag=true;
          this.actionFlag=true;
         }
         if(this.makerFlag){
          this.makerId=this.user.entityCode;
          this.makerComment=this.f.commentForMaker.value;
          this.checkerId=null;
          this.checkerComment=null;
        }
        if(this.checkerFlag){
          this.makerId=this.readOnlyData.maker;
          this.makerComment=this.readOnlyData.makerComment;
          this.checkerId=this.user.entityCode;
          this.checkerComment=this.f.commentForChecker.value;
        }

      
        if(this.readOnlyData.makerComment==null){
          this.makerCommentFlag=true;
        }

        if(this.readOnlyData.checkerComment==null){
          this.checkerCommentFlag=true;
        }

      this.memCode=this.readOnlyData.memberCode;

    }

    back(){
      if(this.entityType =='ENIT'){
        this.router.navigate(['eCompliance/halfYearlyNetworth/reportSubmissionMember'])
        //$('#nillSubmission').modal('hide');
      }
      else if(this.entityType =='ADMIN'){
        this.router.navigate(['complianceAdmin/halfYearlyNetworthAdmin/halfYearlyNetworthList'])
        //$('#nillSubmission').modal('hide');
      }
    }

    downloadFile(fileName:any){
      let systemFileName : string = fileName.target.value;
      this.halfYearlyService.downloadNetworthFile(systemFileName).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response: any) => {
        if (response.statusCode == 200) {
          let file = response.data;
          let contentType = 'text/pdf';
          let blob = base64StringToBlob(file, contentType);
          saveAs(blob, systemFileName, {
            autoBOM: true
          });
          this.toastr.success(response.message);
        } else {
          this.toastr.error(response.message);
        }
      })
    }

    getMemberLimit(){
      this.halfYearlyService.getMemberLimitDetails(this.memCode).pipe(
        catchError((error: any) => {
          this.limit = null;
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.memberDetails = response.data;
          this.limit = this.memberDetails.memMinNwrth;
          if(this.f.totalNetworth.value<=this.limit)
          {
          this.alert=true;
          }
          else{
          this.alert=false;
          }
      }});
    }

    getMemberCategory(){
      this.halfYearlyService.getMemberCategory(this.memCode).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.memCategory = response.data.data.memCategory;
          this.limit = response.data.data.minimumNetworth;
          this.f.memCategory.setValue(this.memCategory);
          this.f.minNetworth.setValue(this.limit);
      }});
    }

   


}
